module.exports = __webpack_public_path__ + "static/media/search.e71cce69.svg";